<template>
  <div class="sp-template">
    <div class="h-title">权限分配</div>
    <el-card class="box-card">
      <div class="f-container">
        <div class="f-container__left sp-tree">
          <el-button v-if="in_configs(70201)" size="small" class="btn-cyan" @click="addRole">新增角色</el-button>
          <el-input size="small" placeholder="输入关键字进行过滤" v-model="filterText" clearable></el-input>
          <el-tree class="filter-tree" v-loading="loading" node-key="id" :data="data1" :props="defaultProps" default-expand-all :filter-node-method="filterNode" ref="tree2" :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span @click="handleNodeClick(data)">
                <span v-if="!data.handle">{{ data.label }}</span>
                <el-input v-else style="width:120px;" size="mini" v-model.lazy="data.label"></el-input>
              </span>
              <span class="f-r">
                <span v-if="data.id != 0">
                  <el-button style="padding:0;" v-if="!data.handle" type="text" size="mini" @click="() => handle(data)"> 编辑</el-button>
                  <el-button style="padding:0;" v-else type="text" size="mini" @click="() => save(data)"> 保存</el-button>
                  <el-button style="padding:0;" type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
                </span>
              </span>
            </span>
          </el-tree>
        </div>
        <div class="f-container__right">
          <div class="f-container__content">
            <h3>权限分配</h3>
            <el-tree class="filter-tree m-t-10" default-expand-all show-checkbox node-key="id" :data="data" ref="tree1" @check-change="handleCheckChange"></el-tree>
          </div>
          <el-button v-if="in_configs(70202)" size="small" class="m-t-20" type="primary" @click="editRole">确 定</el-button>
        </div>
      </div>
    </el-card>
    <el-dialog title="新增角色" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('roleForm')">
      <el-form :model="roleForm" size="small" status-icon :rules="rules" ref="roleForm">
        <el-form-item label="角色" :label-width="formLabelWidth" prop="name">
          <el-input v-model.lazy="roleForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="启用状态" :label-width="formLabelWidth">
          <el-radio v-model="roleForm.status" label="1">启用</el-radio>
          <el-radio v-model="roleForm.status" label="0">停用</el-radio>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-tree class="filter-tree m-t-10" default-expand-all show-checkbox node-key="id" :data="data" ref="tree" @check-change="handleCheckChange"></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('roleForm')">取 消</el-button>
        <el-button size="small" type="primary" @click="submitCreate('roleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      this.$request1({
        method: 'GET',
        url: '/role/check',
        params: { name: value }
      })
        .then(response => {
          console.log(response.data.success);
          if (response.data.success) {
            callback();
          } else {
            callback(new Error("角色名称已存在"));
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    return {
      loading: true,
      name: "",
      roleForm: { id: "", name: "", status: "1" },
      rules: {
        name: [
          { required: true, message: "请填写角色名称", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ]
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      filterText: "",
      role: [],
      data1: [
        {
          id: 0,
          label: "角色",
          children: []
        }
      ],
      data: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.$request1({
        method: 'POST',
        url: '/role/create',
        data: JSON.stringify(this.roleForm),
        headers: { "Content-Type": "application/json" },
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.queryRole();
        })
        .catch(error => {
          console.log(error);
        });
      this.loadMenus();
      this.loading = false;
    }, 1000);
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },

  methods: {
    //编辑
    handle(data) {
      this.$set(data, "handle", true);
      this.name = data.label;
    },
    //保存
    save(data) {
      data.handle = false;
      if (data.label == this.name) {
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/role/edit',
        params: {
          id: data.id,
          name: data.label
        }
      })
        .then(response => {
          if (response.data.success) {
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success"
            });
          } else {
            this.$notify.info({
              title: "提示",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //删除
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'GET',
            url: '/role/delete',
            params: {
              id: node.data.id
            }
          })
            .then(response => {
              if (response.data.length > 0) {
                this.$notify.info({
                  title: "提示",
                  message:
                    "无法删除该角色，" +
                    response.data +
                    "属于该角色，请先去修改员工的角色"
                });
              } else {
                this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success"
                });
                children.splice(index, 1);
                this.roleForm.id = "";
                this.roleForm.name = "";
                this.$refs.tree1.setCheckedKeys([]);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(_ => {});
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //加载menus
    loadMenus() {
      this.$request1({
        method: 'GET',
        url: '/role/loadMenus'
      })
        .then(response => {
          this.data = response.data.menus;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //加载角色
    queryRole() {
      this.$request1({
        method: 'GET',
        url: '/role/query'
      })
        .then(response => {
          let newRoleChild = [];
          if (response.data.data) {
            this.role = response.data.data;
            for (var i = 0; i < this.role.length; i++) {
              newRoleChild.push({
                id: this.role[i].id,
                label: this.role[i].name
              });
            }
          }
          this.data1[0].children = newRoleChild;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //点击角色，显示该角色的权限
    handleNodeClick(data) {
      let menuIds = [];
      this.roleForm.id = data.id;
      if (this.data1[0].children.length > 0) {
        for (var i = 0; i < this.role.length; i++) {
          if (data.id == this.role[i].id) {
            menuIds = eval(this.role[i].menuIds);
          }
        }
      }
      if (menuIds == null) {
        this.$refs.tree1.setCheckedKeys([]);
      } else {
        let menusNodes = [];
        for (var i = 0; i < this.data.length; i++) {
          let children = this.data[i].children;
          if (children != undefined) {
            for (var j = 0; j < children.length; j++) {
              let children2 = children[j].children;
              if (children2 == undefined) {
                for (var a = 0; a < menuIds.length; a++) {
                  if (menuIds[a] == children[j].id) {
                    menusNodes.push(children[j].id);
                  }
                }
              }
            }
          } else {
            for (var b = 0; b < menuIds.length; b++) {
              if (menuIds[b] == this.data[i].id) {
                menusNodes.push(this.data[i].id);
              }
            }
          }
        }

        for (var i = 0; i < menuIds.length; i++) {
          if (menuIds[i].toString().length > 3) {
            menusNodes.push(menuIds[i]);
          }
        }

        this.$refs.tree1.setCheckedKeys(menusNodes);
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      this.data.checked = checked;
    },
    addRole() {
      this.dialogFormVisible = true;
      this.roleForm.id = "";
      this.roleForm.name = "";
      this.roleForm.status = "1";
    },
    //创建角色权限
    submitCreate(formRules) {
      this.$refs[formRules].validate(valid => {
        if (valid) {
          let menus = this.$refs.tree.getCheckedNodes();
          let menusKeys = this.$refs.tree.getHalfCheckedKeys();
          let menuIds = [];

          if (menusKeys.length > 0) {
            for (var i = 0; i < menusKeys.length; i++) {
              menuIds.push(menusKeys[i]);
            }
          }

          for (var i = 0; i < menus.length; i++) {
            menuIds.push(menus[i].id);
          }
          this.roleForm["menuIds"] = menuIds;
          this.roleForm["size"] = this.data1[0].children.length;
          this.$request1({
            method: 'POST',
            url: '/role/create',
            data: JSON.stringify(this.roleForm),
            headers: { "Content-Type": "application/json" },
            xhrFields: {
              withCredentials: true
            }
          })
            .then(response => {
              this.dialogFormVisible = false;
              this.queryRole();
              this.$refs[formRules].clearValidate();
              this.$refs.tree.setCheckedKeys([]);
              if (response.data.success) {
                this.$message({
                  message: "创建角色成功",
                  type: "success",
                  center: true,
                  duration: 1500
                });
              } else {
                this.$message.error("创建角色失败");
              }
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //清空表单数据
    emptyForm() {
      this.roleForm.id = "";
      this.roleForm.name = "";
      this.roleForm.status = "1";
      this.dialogFormVisible = false;
    },
    //清除验证
    close(formRule) {
      this.dialogFormVisible = false;
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //修改角色权限
    editRole() {
      if (this.roleForm.id == "") {
        this.$alert("请选择需要分配权限的角色", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
        return;
      }
      let menus = this.$refs.tree1.getCheckedNodes();
      let menusKeys = this.$refs.tree1.getHalfCheckedKeys();
      let menuIds = [];

      if (menusKeys.length > 0) {
        for (var i = 0; i < menusKeys.length; i++) {
          menuIds.push(menusKeys[i]);
        }
      }

      for (var i = 0; i < menus.length; i++) {
        menuIds.push(menus[i].id);
      }
      this.roleForm["menuIds"] = menuIds;
      this.$request1({
        method: 'POST',
        url: '/role/editRole',
        data: JSON.stringify(this.roleForm),
        headers: { "Content-Type": "application/json" },
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          this.roleForm.id = "";
          this.roleForm.status = "1";
          this.queryRole();
          this.$message({
            message: "修改成功",
            type: "success",
            center: true,
            duration: 1500
          });
        })
        .catch(error => {
          console.log(error);
          this.$message.error("操作失败");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.f-container {
  margin: -20px 0;
}
.f-container__left {
  > * + * {
    margin-top: 15px;
  }
}
h3 {
  font-weight: normal;
}
.custom-tree-node {
  width: 100%;
  overflow: hidden;
  > span {
    &:first-child {
      float: left;
      width: 120px;
      &:hover {
        color: #409eff;
      }
    }
    &:last-child {
      float: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/user/jurisdiction.vue